import { Component, ElementRef, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { DataService } from '../../../services/data.service';
import { Verify } from 'crypto';
import { VerifyService } from 'src/app/services/verify.service';
import { catchError } from 'rxjs/operators';
import { throwError } from 'rxjs';
import { InfoModalComponent } from '../info-modal/info-modal.component';
import { Router } from '@angular/router';
import { ErrorModalComponent } from '../error-modal/error-modal.component';

@Component({
  selector: 'app-resend-verify',
  templateUrl: './resend-verification.component.html',
  styleUrls: ['./resend-verification.component.scss']
})
export class ResendVerification implements OnInit {

  @Input() public email;
  @Input() public language;
  @Input() public message;

  public errorMessage = '';

  public languages = [
    {
      label: 'ENGLISH',
      value: 'ENG'
    },
    {
      label: 'NEDERLANDS',
      value: 'NLD'
    }
  ];
  isProcessing: boolean = false;
  processText: string = "Processing Request";

  constructor(
    public activeModal: NgbActiveModal,
    public service: VerifyService,
    public modalService: NgbModal,
    public router: Router,
  ) {
  }

  ngOnInit() {

  }

  resend() {
    this.errorMessage = '';
    this.isProcessing = true;
    this.service.resendVerifyLink(this.email, this.language)
      .subscribe(res => {
        this.isProcessing = false;
        this.activeModal.close();

        const infoDlg = this.modalService.open(InfoModalComponent);
        infoDlg.componentInstance.data = {
          text: 'verification_link_reach',
          header: 'thanks_for_your_collaboration'
        };
        infoDlg.result.then(() => this.router.navigate(['/login']));
      }, err => {
        this.errorMessage = err.error.error;
        this.isProcessing = false;
        const infoDlg = this.modalService.open(InfoModalComponent);
        infoDlg.componentInstance.data = {
          text: this.errorMessage,
          header: 'Failure!'
        };
      })
  }

}
